/* global Liferay */

import { ENDPOINT, RELATIONSHIP, RELATIONSHIP_FIELD, RELATIONSHIP_NAME } from "../utils/constants";

import { request } from "../utils/request";
import { getCurrentUserId } from "../utils/util";


export const enrollToCourse = (courseId) => {
  return request({
    url: `${ENDPOINT.ENROLLMENTS}`,
    method: "post",
    data: {
      active: true,
      [RELATIONSHIP_FIELD.COURSES_IN_ENROLLMENTS]: courseId,
      [RELATIONSHIP_FIELD.USERS_IN_ENROLLMENTS]: getCurrentUserId(),
    },
  });
};

export const enrollToCourseAndCompleteAsset = (courseId, assetId) => {
  return request({
    url: `${ENDPOINT.ENROLLMENTS}`,
    method: "post",
    data: {
      active: true,
      completedAssetIds: assetId,
      [RELATIONSHIP_FIELD.COURSES_IN_ENROLLMENTS]: courseId,
      [RELATIONSHIP_FIELD.USERS_IN_ENROLLMENTS]: getCurrentUserId(),
    },
  });
};

export const enrollToLearningPath = (learningPathId) => {
  return request({
    url: `${ENDPOINT.ENROLLMENTS}`,
    method: "post",
    data: {
      [RELATIONSHIP_FIELD.LEARNING_PATHS_IN_ENROLLMENTS]: learningPathId,
      [RELATIONSHIP_FIELD.USERS_IN_ENROLLMENTS]: getCurrentUserId(),
    },
  });
};

export const getAttachmentsByLessonId = (lessonId) => {
  return request({
    url: `${ENDPOINT.LESSONS}/${lessonId}/attachment?page=0`,
    method: "get",
  });
};

export const getCoursesAndFirstLessons = async () => {
  const data = await request({
    url: `${ENDPOINT.MODULES}?filter=position eq 0&nestedFields=${RELATIONSHIP.COURSES_TO_MODULES},${RELATIONSHIP.MODULES_TO_LESSONS}&pageSize=-1`,
    method: "get",
  });
  return data.items;
};

export const getVisibleCourseAssetIds = async (courseId) => {
  const fields = [
    `${RELATIONSHIP.COURSES_TO_MODULES}.id`,
    `${RELATIONSHIP.COURSES_TO_MODULES}.${RELATIONSHIP.MODULES_TO_LESSONS}.id`,
    `${RELATIONSHIP.COURSES_TO_MODULES}.${RELATIONSHIP.MODULES_TO_QUIZZES}.id`,
  ];

  const data = await request({
    url: `${ENDPOINT.COURSES}?filter=id eq '${courseId}'&nestedFields=${RELATIONSHIP.COURSES_TO_MODULES},${RELATIONSHIP.MODULES_TO_LESSONS},${RELATIONSHIP.MODULES_TO_QUIZZES}&nestedFieldsDepth=2&fields=${fields.join(",")}`,
    method: "get",
  });

  const course = data?.items?.[0];

  if (!course) {
    return null;
  }

  const assetIds = [];

  for (const module of course[RELATIONSHIP.COURSES_TO_MODULES] ?? []) {
    for (const lesson of module[RELATIONSHIP.MODULES_TO_LESSONS] ?? []) {
      assetIds.push(lesson.id);
    }

    for (const quiz of module[RELATIONSHIP.MODULES_TO_QUIZZES] ?? []) {
      assetIds.push(quiz.id);
    }
  }

  return assetIds;
};

export const getCourseByAssetTypeAndId = async (assetType, assetId) => {
  const response = await Liferay.Util.fetch(
    `${ENDPOINT.MODULES}?fields=${RELATIONSHIP_FIELD.COURSES_IN_MODULES}&filter=${assetType}/id eq '${assetId}'`
  );

  const data = await response.json();

  if (data.items.length) {
    const firstItem = data.items[0];
  
    return firstItem[RELATIONSHIP_FIELD.COURSES_IN_MODULES];
  }

  return null;
};

export const getCourseByModuleAssetTypeAndId = async (assetType, assetId) => {
  const response = await Liferay.Util.fetch(
        `${ENDPOINT.COURSES}?filter=${RELATIONSHIP.COURSES_TO_MODULES}/${assetType}/id eq '${assetId}'`
      );

    const data = await  response.json();

    return data.items[0];
}

export const getCourseInfoByCourseId = async (courseId) => {
  const data = await request({
    url: `${ENDPOINT.COURSES}/${courseId}`,
    method: "get",
  })
  return data;
}

export const getEnrollmentsByCourseId = (courseId) => {
  let parsedId = isNaN(parseInt(courseId)) ? -1 : parseInt(courseId);

  return request({
    url: `${ENDPOINT.ENROLLMENTS}?filter=${RELATIONSHIP_FIELD.COURSES_IN_ENROLLMENTS} eq '${parsedId}' and ${RELATIONSHIP_FIELD.USERS_IN_ENROLLMENTS} eq '${getCurrentUserId()}'`,
  });
};

export const getEnrollmentsByLearningPathId = (learningPathId) => {
  let parsedId = isNaN(parseInt(learningPathId))
    ? -1
    : parseInt(learningPathId);

  return request({
    url: `${ENDPOINT.ENROLLMENTS}?filter=${RELATIONSHIP_FIELD.LEARNING_PATHS_IN_ENROLLMENTS} eq '${parsedId}' and ${RELATIONSHIP_FIELD.USERS_IN_ENROLLMENTS} eq '${getCurrentUserId()}'`,
  });
};

export const getExercisesByModuleId = (moduleId) => {
  return request({
    url: `${ENDPOINT.MODULES}/${moduleId}/exercise?page=0`,
    method: "get",
  });
};

export const getFirstLessonIdByCourseId = async (courseId) => {
  const data = await request({
    url: `${ENDPOINT.MODULES}?filter=${RELATIONSHIP_FIELD.COURSES_IN_MODULES} eq '${courseId}' and position eq 0&nestedFields=${RELATIONSHIP.MODULES_TO_LESSONS}`,
    method: "get",
  });

  const items = data.items[0];

  return items[RELATIONSHIP.MODULES_TO_LESSONS][0].id;
};

export const getLessonById = (lessonId) => {
  return request({
    url: `${ENDPOINT.LESSONS}/${lessonId}`,
    method: "get",
  });
};

export const getLessonByModuleId = (moduleId) => {
  return request({
    url: `${ENDPOINT.MODULES}/${moduleId}/lesson?page=0&pageSize=100`,
    method: "get",
  });
};

export const getModulesByCourseId = (courseId) => {
  return request({
    url: `${ENDPOINT.COURSES}/${courseId}/module?page=0`,
    method: "get",
  });
};

export const getListTypeEntriesByExternalReferenceCode = async (externalReferenceCode) => {
  const data = await request({
    url: `/o/headless-admin-list-type/v1.0/list-type-definitions/by-external-reference-code/${externalReferenceCode}/list-type-entries`,
    method: 'get'
  });
  return data;
};

export const getSortedCourses = async () => {
  const data = await request({
    url: `${ENDPOINT.COURSES}?pageSize=-1&sort=position:asc`,
    method: "get",
  });
  return data.items;
};

export const getSortedCoursesFilteredByFirstLesson = async () => {
  const data = await getCoursesAndFirstLessons();

  return data
    .filter((course) => course[RELATIONSHIP.MODULES_TO_LESSONS] && course[RELATIONSHIP_FIELD.COURSES_IN_MODULES])
    .sort(
      (a, b) => a[RELATIONSHIP_FIELD.COURSES_IN_MODULES].position - b[RELATIONSHIP_FIELD.COURSES_IN_MODULES].position
    )
    .map((course) => ({
      ...course[RELATIONSHIP_NAME.COURSES_IN_MODULES],
      firstLesson: course[RELATIONSHIP.MODULES_TO_LESSONS][0]?.id,
      firstLessonFriendlyUrlPath: course[RELATIONSHIP.MODULES_TO_LESSONS][0]?.friendlyUrlPath,
    }))
    .filter((course) => course.firstLesson && course.firstLessonFriendlyUrlPath);
}